import { Badge } from '@hgc/ui';
import type { JSX } from 'react';

import { useLinkStatus } from '../runtime/hooks';

/**
 * 标题栏上的链路状态：等级徽标 + 链路标识 + **失败原因**。
 *
 * 那一句原因是这里的重点。GCS 里"连不上"有十几种可能（没授权串口、浏览器不支持 Web Serial、
 * 地址写错、HTTPS 页面连明文 ws://、对端没上电…），而它们的处理方式完全不同。
 * 只显示"未连接"等于把所有情况合并成一个用户无法行动的黑洞，
 * 所以 `reason` 由运行时从会话/传输的真实报错翻译而来，并且**始终显示在标题栏**上，
 * 而不是藏在某个诊断面板里。
 */
export function LinkStatusBadge(): JSX.Element {
  const status = useLinkStatus();

  return (
    <div className="flex min-w-0 items-center gap-2">
      <Badge level={status.level} dot>
        {status.title}
      </Badge>

      {status.transportLabel === null ? null : (
        <span className="shrink-0 text-xs text-fg-muted">{status.transportLabel}</span>
      )}

      {status.reason === null ? null : (
        <span className="max-w-[26rem] truncate text-xs text-fg-subtle" title={status.reason}>
          {status.reason}
        </span>
      )}
    </div>
  );
}
